import { createFileRoute } from '@tanstack/react-router';

import { EarlyAccessPage } from '../components/marketing/EarlyAccessPage';

/** /earlyaccessvenue — the early-access page with the venue toggle preset. */
export const Route = createFileRoute('/earlyaccessvenue')({
  component: () => <EarlyAccessPage initialLeadType="venue" />,
});
